import {Component} from '@angular/core';
import {BaseActivityComponent} from '../base-activity.component';
import {Observable, of} from 'rxjs';
import {ImageActivityGranule} from '@modules/activities/core/models/activities/typologies/image-activity.granule';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html'
})
export class ImageComponent extends BaseActivityComponent<ImageActivityGranule>{
    public questionObject: ImageActivityGranule['attributes']['reference'];
    public imageUrl: string;

    protected setContentData(activityAttributes: ImageActivityGranule['attributes']): void {
        this.questionObject = activityAttributes.reference;
        this.instruction = this.questionObject.instruction;
        this.wording = this.questionObject.wording;
        this.instructionAudio = this.questionObject.instructionAudio;
        this.wordingAudio = this.questionObject.wordingAudio;

        if(this.questionObject.activity_content.length === 0) {
            throw new Error('No media content found');
        }

        this.imageUrl = this.questionObject.activity_content[0].image;
    }

    /**
     * create answer entered by the user.
     * no need to create answer because answer already exist.
     * method needed for save in baseActivityComponent
     * @protected
     */
    protected saveAnswer(): Observable<number[]> {
        return of(null);
    }

    protected reviewAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected seeAnswerSolution(): void {
        throw new Error('Method not implemented.');
    }

    protected checkAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected setAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected  getGrade(): {oldGrade: number, newGrade: number} {
        throw new Error('Method not implemented.');
    }

    protected getAttempts(): number {
        throw new Error('Method not implemented.');
    }


    protected validate(): void {
        throw new Error('Method not implemented.');
    }
}
